export default __webpack_public_path__ + "static/media/eqstk.7d873b78.svg";